'use client'

import styles from "./HeroSection.module.scss";
import Image from 'next/image';
import Text from '@components/atoms/Text';
import { useRouter } from 'next/navigation';
import assetLoader from '@utils/internalImageLoder';
import { closeWebView } from "@hooks/useWebviewCallback";
import { useIsMobile } from '@hooks/use-mobile';

const HeroSection = () => {

  const router = useRouter();
  const isMobile = useIsMobile();

  const handleCloseContest = async () => {
    closeWebView(() => router.back());
  }

  return (
    <>
      <div className={styles.carDropWinnerContainer}>
        <div
          className={styles.carDropContainerHeader}
        >
          <Image
            src={`${assetLoader()}/icons/Chevron_left_light.svg`}
            alt='arrow icon'
            width={24}
            height={24}
            loading='eager'
            className={styles.carDropBackIcon}
            onClick={handleCloseContest}
          />
          <Image
            src={`${assetLoader()}/images/CarDropLogo.svg`}
            alt='arrow icon'
            fill
            loading='eager'
            className={styles.carDropLogo}
          />
        </div>
        <div className={styles.winnerHSTopSectionHeadings}>
            <Text className={styles.winnerHSTopSectionSubHead}>Meet our</Text>
            <Text className={styles.winnerHSTopSectionHead}>November Car Drop Winner</Text>
        </div>
         <Image
          src={`${assetLoader()}/images/mahindraRevealImage.png`}
          alt='arrow icon'
          fill
          loading='eager'
          className={styles.carRevealName}
        />
          {
            isMobile ?
              <div className={styles.videoWrapper}>
                 <video
                  src={`${assetLoader()}/winnerVideo.webm`}
                  className={styles.carDropHeroMobileVideo}
                  autoPlay
                  playsInline
                  muted
                  preload="auto"
                  controls
                />
              </div>
              :
              <video
                src={`${assetLoader()}/winnerVideo.webm`}
                className={styles.carDropHeroVideo}
                autoPlay
                playsInline
                muted
                preload="auto"
                controls
              />
          }
      </div>
    </>
  )
}

export default HeroSection;